import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar } from '@fortawesome/free-solid-svg-icons';

const CustomMarker = () => {
    return (
        <div style={{ color: 'red', fontSize: '30px' }}>
            <FontAwesomeIcon icon={faCar} />
        </div>
    );
};

export default CustomMarker;